import { useState } from "react";
import { BASE_URL } from "../constants";
import { Modal, Input, Btn } from "./UI";

export default function EditJobModal({ job, token, onClose, onSuccess }) {
  const [form, setForm] = useState({
    title:         job.title,
    salaryMin:     job.salaryMin,
    salaryMax:     job.salaryMax,
    totalOpenings: job.totalOpenings,
    description:   job.description  || "",
    requirements:  job.requirements || "",
    contactEmail:  job.contactEmail || "",
    contactPhone:  job.contactPhone || "",
  });
  const [loading, setLoading] = useState(false);

  const f = (k) => (e) => setForm(p => ({ ...p, [k]: e.target.value }));

  const submit = async () => {
    setLoading(true);
    try {
      const res  = await fetch(`${BASE_URL}/agent/job/update/${job._id}`, {
        method:  "PATCH",
        headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` },
        body:    JSON.stringify({
          ...form,
          salaryMin:    +form.salaryMin,
          salaryMax:    +form.salaryMax,
          totalOpenings: +form.totalOpenings,
        }),
      });
      const data = await res.json();
      if (data.success) onSuccess("Job updated! Pending re-approval.");
      else onSuccess(data.message || "Update failed.", "error");
    } catch {
      onSuccess("Network error.", "error");
    }
    setLoading(false);
  };

  return (
    <Modal title={`Edit: ${job.title}`} onClose={onClose}>
      <Input label="Job Title" value={form.title} onChange={f("title")} />
      <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 8 }}>
        <Input label="Min Salary (₹)" type="number" value={form.salaryMin}     onChange={f("salaryMin")} />
        <Input label="Max Salary (₹)" type="number" value={form.salaryMax}     onChange={f("salaryMax")} />
        <Input label="Total Openings" type="number" value={form.totalOpenings} onChange={f("totalOpenings")} />
        <Input label="Contact Email"  type="email"  value={form.contactEmail}  onChange={f("contactEmail")} />
        <Input label="Contact Phone"  type="tel"    value={form.contactPhone}  onChange={f("contactPhone")} />
      </div>

      <div style={{ display: "flex", gap: 10, justifyContent: "flex-end", marginTop: 8 }}>
        <Btn variant="secondary" onClick={onClose}>Cancel</Btn>
        <Btn onClick={submit} disabled={loading}>{loading ? "Saving…" : "Save Changes"}</Btn>
      </div>
    </Modal>
  );
}